<template>

    <div>
        <v-row no-gutters>
            <base-header>
                <div slot="page-header">API Chat</div>
            </base-header>
        </v-row>

        <v-row no-gutters>

            <v-col cols="12" lg="12" xl="12">
                <base-card>
                    <div slot="card-header">

                    </div>
                    <div slot="card-body">
                        <v-card>
                            <v-toolbar flat dark>
                                <v-toolbar-title>API Chat</v-toolbar-title>
                            </v-toolbar>
                            <v-tabs vertical>
                                <v-tab>
                                    <v-icon left>
                                        mdi-account
                                    </v-icon>
                                    API
                                </v-tab>
                                

                                <v-tab-item>
                                    <base-card>
                                        <div slot="card-body">
                                            <v-row>
                                                <v-col cols="4">
                                                    <v-subheader>Twitter API</v-subheader>
                                                </v-col>
                                                <v-col cols="8">
                                                    <v-text-field label="Key API" outlined dense></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="4">
                                                    <v-subheader>Telegram API</v-subheader>
                                                </v-col>
                                                <v-col cols="8">
                                                    <v-text-field label="Key API" outlined dense></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="4">
                                                    <v-subheader>WhattsApp</v-subheader>
                                                </v-col>
                                                <v-col cols="8">
                                                    <v-text-field label="Key API" outlined dense></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="4">
                                                    <v-subheader>FAcebook</v-subheader>
                                                </v-col>
                                                <v-col cols="8">
                                                    <v-text-field label="Key API" outlined dense></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="4">
                                                    <v-subheader>Instagram</v-subheader>
                                                </v-col>
                                                <v-col cols="8">
                                                    <v-text-field label="Key API" outlined dense></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-btn color="primary" block>
                                                Connect
                                            </v-btn>
                                        </div>
                                    </base-card>
                                </v-tab-item>
                                <v-tab-item>
                                    <v-card flat>
                                        <card-security></card-security>
                                    </v-card>
                                </v-tab-item>

                            </v-tabs>
                        </v-card>
                    </div>
                </base-card>
            </v-col>

        </v-row>
        <card-slide-group></card-slide-group>

    </div>
</template>

<script>
    import BaseCard from "../../components/Base/BaseCard.vue";
    import BaseHeader from "../../components/Base/BaseHeader.vue";
    import CardInformation from '../../components/Cards/CardInformation'
    import CardSecurity from '../../components/Cards/CardSecurity'
    import CardSlideGroup from '../../components/Cards/CardSlideGroup'
    export default {
        components: {
            BaseCard,
            BaseHeader,
            CardInformation,
            CardSecurity,
            CardSlideGroup


        },
    }
</script>